export default __webpack_public_path__ + "static/media/placeholders.54ec4b84.svg";